import ManagedErrorToasts from '@/components/error/ManagedErrorToasts';
import type { ReviewNewScriptInterface } from '@/components/escript/token/types';
import { createContext, useMemo, useState } from 'react';

export interface ScriptTokenContextType {
  reviewNewScriptsState: boolean;
  setReviewNewScriptsState: React.Dispatch<React.SetStateAction<boolean>>;
  addNewScriptsState: boolean;
  setAddNewScriptsState: React.Dispatch<React.SetStateAction<boolean>>;
  newSubmittedScripts: ReviewNewScriptInterface[];
  setNewSubmittedScripts: React.Dispatch<React.SetStateAction<ReviewNewScriptInterface[]>>;
}

export const ScriptTokenContext = createContext<ScriptTokenContextType | undefined>(undefined);

export const ScriptTokenStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [reviewNewScriptsState, setReviewNewScriptsState] = useState<boolean>(false);
  const [addNewScriptsState, setAddNewScriptsState] = useState<boolean>(false);
  const [newSubmittedScripts, setNewSubmittedScripts] = useState<ReviewNewScriptInterface[]>([]);

  const value = useMemo(() => {
    return {
      reviewNewScriptsState,
      setReviewNewScriptsState,
      addNewScriptsState,
      setAddNewScriptsState,
      newSubmittedScripts,
      setNewSubmittedScripts,
    };
  }, [reviewNewScriptsState, addNewScriptsState, newSubmittedScripts]);

  return (
    <ScriptTokenContext.Provider value={value}>
      <ManagedErrorToasts />
      {children}
    </ScriptTokenContext.Provider>
  );
};
